import { Injectable } from '@angular/core';

import { OnDemandPublicTrip, RidangoReduxAction } from '@ridango/core';

@Injectable()
export class OnDemandTripsActions {
    static FETCH_ONDEMAND_TRIPS = '[Schedule]: Fetch ondemand trips';
    static FETCH_ONDEMAND_TRIPS_SUCCESS = '[Schedule]: Fetch ondemand trips successful';
    static FETCH_ONDEMAND_TRIPS_FAIL = '[Schedule]: Fetch ondemand trips failed';

    static FETCH_UPCOMING_TRIPS = '[Schedule]: Fetch Upcoming Ondemand Trips';
    static FETCH_UPCOMING_TRIPS_SUCCESS = '[Schedule]: Fetch Upcoming Ondemand Trips Success';
    static FETCH_UPCOMING_TRIPS_FAIL = '[Schedule]: Fetch Upcoming Ondemand Trips Failed';

    static ADD_POLYLINE = '[Schedule]: Add polyline';

    static SET_SELECTED_TRIP = '[Schedule]: Set selected trip';

    fetchOnDemandTrips(date): RidangoReduxAction {
        return {
            type: OnDemandTripsActions.FETCH_ONDEMAND_TRIPS,
            payload: date,
        };
    }

    fetchOnDemandTripsSuccess(payload) {
        return {
            type: OnDemandTripsActions.FETCH_ONDEMAND_TRIPS_SUCCESS,
            payload: payload,
        };
    }

    fetchOnDemandTripsFail() {
        return {
            type: OnDemandTripsActions.FETCH_ONDEMAND_TRIPS_FAIL,
        };
    }

    fetchUpcomingTrips(): RidangoReduxAction {
        return {
            type: OnDemandTripsActions.FETCH_UPCOMING_TRIPS
        };
    }

    fetchUpcomingTripsSuccess(payload: OnDemandPublicTrip[]): RidangoReduxAction {
        return {
            type: OnDemandTripsActions.FETCH_UPCOMING_TRIPS_SUCCESS,
            payload: payload,
        };
    }

    fetchUpcomingTripsFailed(payload): RidangoReduxAction {
        return {
            type: OnDemandTripsActions.FETCH_UPCOMING_TRIPS_FAIL,
            payload: payload,
        };
    }

    addPolyline(payload: string): RidangoReduxAction {
        return {
            type: OnDemandTripsActions.ADD_POLYLINE,
            payload: payload,
        };
    }

    setSelectedTrip(payload: OnDemandPublicTrip): RidangoReduxAction {
        return {
            type: OnDemandTripsActions.SET_SELECTED_TRIP,
            payload: payload,
        }
    }

}
